export default __webpack_public_path__ + "static/media/trading-academy-logo.bcb732cd.svg";